import React, { useState, useEffect } from "react";
import "./Karte1.css";
import { useNavigate } from "react-router-dom";

const Menu = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/categories/order`
      );
      const data = await response.json();

      // "Special" und "Musik Night" immer zuerst anzeigen
      const specialCategories = data.filter(
        (item) => item.category === "Special" || item.category === "Musik Night"
      );
      const otherCategories = data.filter(
        (item) => item.category !== "Special" && item.category !== "Musik Night"
      );

      // Kombiniere "Special" und "Musik Night" zuerst, gefolgt von den restlichen Kategorien
      setCategories([...specialCategories, ...otherCategories]);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleCategoryClick = (category) => {
    navigate(`/menu/${category}`);
  };

  if (!isMobile) return null;

  return (
    <div className="menu-fullscreen-wrapper stars">
      <div className="shooting-star-reverse"></div>
      <div className="menu-content">
        <h2 className="menu-heading1">Menü</h2>
        <div className="menu-category-list">
          {categories.map((category, index) => (
            <button
              key={index}
              onClick={() => handleCategoryClick(category.category)}
              className={`menu-category-button ${
                category.category === "Special" || category.category === "Musik Night"
                  ? "special-category"
                  : ""
              }`}
            >
              {category.category}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Menu;
